import angular from 'angular';

export default angular.module('app.filters.zip-code', []).filter(
  'zipCode',
  () =>
    function(zip) {
      if (zip == null) {
        zip = '';
      }
      return zip.split('-')[0];
    }
);
